module.exports = __webpack_public_path__ + "img/part4-1.151b631b.png";